import React from 'react';

function Home() {
    return <div>My CV will be here soon.</div>;
}

export default Home;
